module.exports = __webpack_public_path__ + "img/01.e9bc76c6.png";